import { useEffect, useState } from "react";
import { Breadcrumbs } from "../../../Home/Breadcrumb"
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useArea } from "../../../../hooks/useArea";
import { Area } from "../../../../types/Area";
import { ToastContainer, toast } from "react-toastify";
import Accordion from "../../../../components/Accordion";
import FormInput from "../../../../components/Form/FormInput";
import FormSelectBox from "../../../../components/Form/FormSelectBox";
import Confirm from "../../../../components/Confirm";


export type FormAreaErrors = {
    nombre?: string;
};

const estados = [
    { id: 'true', valor: 'ACTIVA' },
    { id: 'false', valor: 'INACTIVA' },
];

export const CrearArea = () => {
    const { handleAreaSelected, areaInitial, areaSelected, guardarArea, buscarArea } = useArea();

    const [areaForm, setAreaForm] = useState<Area>(areaInitial);
    const [edit, setEdit] = useState<boolean>(false);
    const [view, setView] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const toggle = () => setShowModal(!showModal);

    const [formErrors, setFormErrors] = useState<FormAreaErrors>({ nombre: '' });

    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (id) {
            buscarArea(id);
            setEdit(true);
            const accionActual = searchParams.get("action");
            if (accionActual === 'view') {
                setView(true);
            }
        } else {
            handleAreaSelected(areaInitial)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setAreaForm(areaSelected)
    }, [areaSelected])

    const onChangeArea = (e: any) => {
        const { name, value } = e.target;
        // El combo de Estado incluye la opcion vacia "Seleccionar": se ignora para no dejar el area inactiva sin querer
        if (name === 'activo' && value === '') {
            return;
        }
        setAreaForm({
            ...areaForm,
            [name]: name === 'activo' ? value === 'true' : value
        });
        if (name === 'nombre') {
            setFormErrors({ nombre: value.trim() ? '' : 'El campo Nombre es obligatorio' });
        }
    }

    const handleGuardar = () => {
        if (!areaForm.nombre?.trim()) {
            toast.error('Debe informar el campo [Nombre]');
            setFormErrors({ nombre: 'El campo Nombre es obligatorio' });
            return;
        }

        guardarArea({
            ...areaForm,
            nombre: areaForm.nombre.trim(),
            id: areaForm.id || undefined,
        })
            .then(() => {
                // El mensaje de exito lo muestra el listado al montarse (flag guardado): si se emite aca se pierde al navegar
                navigate('/areas');
            })
            .catch(err => {
                if (err.response?.status === 403) {
                    toast.error('No tiene permisos para realizar esta acción');
                } else {
                    toast.error(err.response?.data?.message || 'Hubo un error al guardar el Área')
                }
            })
    }

    const handleCancelar = (e: any) => {
        e.preventDefault();
        setShowModal(true)
    }
    const cancelar = () => {
        toggle();
        navigate('/areas')
    }
    const handleVolver = () => {
        navigate('/areas')
    }

    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={edit ? (view ? 'Vista' : 'Editar') : 'Nuevo'}
                            titlePage={view ? 'Vista Áreas' : 'Áreas'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                            nameSecond={'Áreas'}
                            urlSecond={'/areas'}
                        />
                        <Confirm isOpen={showModal} toggle={toggle} title='Cancelar' yesFn={cancelar}>
                            <div className="form-horizontal">
                                <div className="row">
                                    {<p>Confirma Salir sin guardar los cambios?</p>}
                                </div>
                            </div>
                        </Confirm>

                        <Accordion id={'Area'} title="Área">
                            <div className="pb-3">
                                <div className="row mt-3">
                                    <FormInput
                                        id={'nombre'}
                                        label={'Nombre'}
                                        name={'nombre'}
                                        value={areaForm.nombre || ''}
                                        isDisabled={view}
                                        onChange={onChangeArea}
                                        errorText={formErrors.nombre}
                                        maxLength={100}
                                    />
                                    <FormSelectBox
                                        title={'Estado'}
                                        label={'estado'}
                                        id={'activo'}
                                        name={'activo'}
                                        onChange={onChangeArea}
                                        optionId={'id'}
                                        optionLabel={'valor'}
                                        value={String(areaForm.activo)}
                                        options={estados}
                                        isDisabled={view}
                                    />
                                </div>
                                <div className="row mt-3">
                                    <FormInput
                                        id={'descripcion'}
                                        label={'Descripción'}
                                        name={'descripcion'}
                                        value={areaForm.descripcion || ''}
                                        isDisabled={view}
                                        onChange={onChangeArea}
                                        maxLength={255}
                                    />
                                </div>
                            </div>
                        </Accordion>

                        <br />
                        <div className="text-center">
                            {!view &&
                                <>
                                    <button className="btn btn-secondary mx-2" onClick={handleCancelar}>Cancelar</button>
                                    <button className="btn btn-success mx-2" onClick={handleGuardar}>Guardar</button>
                                </>
                            }
                            {view &&
                                <button className="btn btn-secondary mx-2" onClick={handleVolver}>Volver</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
